import type {State} from "../..";
import {Action} from "../action";
export const CHOOSE_NO_AVAILABLE = "CHOOSE_NO_AVAILABLE";

/**
 * This Action is available on this state due to the fact that there can be false positives in regards to the available basistypes.
 * So it might be possible to choose a Basistype which in fact isn't available.
 */
export class ChooseNoAvailable extends Action<typeof CHOOSE_NO_AVAILABLE, undefined> {
  readonly type = CHOOSE_NO_AVAILABLE;
  protected state: State<any, any>;

  constructor(state: State<any, any>) {
    super(state);
    this.state = state;
  }

  public isValid(): boolean {
    return this.isDoable();
  }
  public isDoable(): boolean {
    return true;
  }
}
